import React = require("react");
import { getSurveyTemplates, loadSurveyTemplate } from "../../../../../../api/surveyClientApi";
import { SegmentationPanel } from "./_components/SegmentationPanel";
import { SurveyInfoPanel } from "./_components/SurveyInfoPanel";
import { ThemeList } from "./_components/ThemeList";
import { LoadingPageOverlay } from "../../../../../../designSystem/LoadingPageOverlay";
import { LanguageCode, SurveyStatus, SurveyTemplateView, getSurveyStatus } from '../../../../../../amorg-common';
import { SurveyTemplatesModal } from "./_components/SurveyTemplatesModal";
import { ToolBarButton, ToolBarContainer } from "../../../../../../designSystem/compositeComponents/ButtonToolBar";
import { PageHeader } from "../../../../../../designSystem/PageHeader";
import { getSurveyStatusLabel } from "./_components/SurveyStatusPanel";
import { WorkplaceAssessmentComponentProps } from "../_components/WorkplaceAssessmentComponentProps";

export function SurveyPanel(props: WorkplaceAssessmentComponentProps): JSX.Element 
{
    const [templates, setTemplates] = React.useState<SurveyTemplateView[]>([]);
    const [showTemplatesModal, setShowTemplatesModal] = React.useState(false);
    const [selectedLanguage, setSelectedLanguage] = React.useState<LanguageCode>(props.survey?.languageCode || 'da');
    
    React.useEffect(() => {
        const getData = async () => {
            setTemplates(await getSurveyTemplates());
        };
        getData();
    }, [props.survey]);

    async function handleSelectTemplate(templateId: string) {
        if(!props.survey)
            return;

        await loadSurveyTemplate(props.survey.id, templateId);
        setShowTemplatesModal(false);
        props.onSurveyUpdated();
    }

    let surveyStatus:SurveyStatus|undefined = undefined;

    let disableEdit = true;
    if (props.survey){
        surveyStatus = getSurveyStatus(props.survey);
        disableEdit = !surveyStatus.canEdit;
    }

    if(!props.survey)
        return <></>;

    return (

        <>
        <LoadingPageOverlay loading={props.surveyLoading} />

        <SurveyTemplatesModal
            show={showTemplatesModal}
            templates={templates} 
            currentSurvey={props.survey}
            onTemplatesChanged={async ()=>setTemplates(await getSurveyTemplates())}
            onSelectTemplate={handleSelectTemplate}
            disabled={disableEdit} 
            onClose={()=>setShowTemplatesModal(false)}
        />

        {props.survey &&
            <>
                <PageHeader
                    headerText="Spørgeskema"
                    subHeader={getSurveyStatusLabel(props.survey)}
                    headerStyle="secondary-gray"
                    buttons={
                        <ToolBarContainer>
                            <ToolBarButton
                                icon="interface_actions_save"
                                tooltip="Vis skabeloner"
                                onClick={ disableEdit ? undefined : ()=>setShowTemplatesModal(true)}
                                variant="text" 
                                disabled={disableEdit}
                                />
                        </ToolBarContainer>
                    }
                />                 

                    
                <SurveyInfoPanel 
                    activity={props.activity} survey={props.survey} 
                    onSurveyUpdated={props.onSurveyUpdated}
                    onActivityUpdated={props.onActivityUpdated}
                    selectedLanguageCode={selectedLanguage}
                    disableEdit={disableEdit}
                    onSelectedLanguageCodeChanged={(code)=>setSelectedLanguage(code)} />

                <SegmentationPanel
                    selectedLanguage={selectedLanguage}
                    survey={props.survey}
                    disableEdit={disableEdit}
                    onUpdated={props.onSurveyUpdated} />
                    
                <ThemeList
                    languageCode={selectedLanguage}
                    survey={props.survey}
                    onSurveyUpdated={props.onSurveyUpdated} />
            </>
        }
        </>     
    );
}